export default __webpack_public_path__ + "1c82d0e215f3e9eab8be61c72d8e7012.svg";